import { render, staticRenderFns } from "./AddNewBranchDeposit.vue?vue&type=template&id=5fa2eac7&scoped=true&"
import script from "./AddNewBranchDeposit.vue?vue&type=script&lang=js&"
export * from "./AddNewBranchDeposit.vue?vue&type=script&lang=js&"
import style0 from "./AddNewBranchDeposit.vue?vue&type=style&index=0&id=5fa2eac7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2eac7",
  null
  
)

export default component.exports